import { call, takeLatest } from 'redux-saga/effects'

import { IArchivingPayload, IReportPayload, IImportBreadlinePayload } from '../models/reportModel'
import { EReportType } from './reportAction'
import { reportService, archivingService, importBreadlineService } from '../../../services/api/reportApi'
import { toast } from 'react-toastify';

function* reportsSaga({ payload, cbSuccess, cbFailure }: IReportPayload) {
    try {
        yield call(reportService, payload);
        cbSuccess?.()
    } catch (error) {
        typeof (error) === 'string' && cbFailure?.(error)
    }
}

function* archivingSaga({ cb }: IArchivingPayload) {
    try {
        yield call(archivingService);
        cb?.()
    } catch (error: any) {
        toast.error(error.message, {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    }
}

function* importBreadlineSaga({ payload, cbSuccess, cbFailure }: IImportBreadlinePayload) {
    try {
        yield call(importBreadlineService, payload);
        cbSuccess?.()
    } catch (error) {
        typeof (error) === 'string' && cbFailure?.(error)
    }
}

export default function* reportsWatcher() {
    yield takeLatest(EReportType.REPORTS_ACTION, reportsSaga)
    yield takeLatest(EReportType.ARCHIVING_ACTION, archivingSaga)
    yield takeLatest(EReportType.IMPORTBREADLINE_ACTION, importBreadlineSaga)
}